"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _en_GB = _interopRequireDefault(require("../../date-picker/locale/en_GB"));
var _default = _en_GB["default"];
exports["default"] = _default;